import React, {useEffect, useState} from 'react'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import {useSelector} from 'react-redux'
import { RootState } from '../../../../../setup'
import { QueryData } from '../../../../reusable-components/tables/DynamicTableTypes'
import {MoonLoader} from 'react-spinners'
import {useHistory} from 'react-router-dom'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import { hasPermission } from '../../../../../_helper/hasPermission'
import { permissions } from '../../../../../_constants/permissions'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import { WOUND_DATA_MAPPING ,WOUND_LISTING_COLOUMS,
  WOUND_SORTING_DATA,} from '../../../wound/WOUND_TABLE_CONSTANTS'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import axios from 'axios'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
const selectAuth = (state: RootState) => state.auth

const DeletedWoundCareList = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [deletedID, setDeletedID] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(false)
  const [loadingStates, setLoadingStates] = useState({})
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId

  const history = useHistory()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const [fullData, setFullData] = useState<any[]>([])

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      try {
        setIsFetchingData(true)
        const response = await axios.get('/wound-assessment/getAll', {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
            isDeleted: true,
          },
        })
        const {data, currentPage, totalCounts} = response?.data
        setFullData(data);
        setFilteredData(data)
        setQueryData((prevState) => {
          return {
            ...prevState,
            currentPage,
            totalCounts,
          }
        })
      } catch (error) {
        console.error('Error fetching wound care:', error)
      } finally {
        setIsFetchingData(false)
      }
    }

    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
    deletedID,
  ])

  if (isFetchingData) {
    return (
      <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
        <MoonLoader color='#9db2fc' size={60} loading={isFetchingData} />
      </div>
    )
  }
  const handleUpdate = (row: any) => {
    history.push(`/deleted-notes/wound-care-notes/${row._id}`)
  }
  const handleView = (row: any) => {
    history.push(`/deleted-notes/wound-care-notes/entry/list/${row.clientId}/${row._id}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        <div>
          <TableTitle title='Deleted Wound Care List' />
          <TableWrapper
            searchField={
              hasPermission(userPermissions, permissions.wound_care_search) && (
                <TableSearchBar
                  label='Search'
                  variant='outlined'
                  size='small'
                  value={searchTerm}
                  setQueryData={setQueryData}
                  setSearchTerm={setSearchTerm}
                  margin='normal'
                />
              )
            }
            dynamicTable={
              <>
              <span className='ml-2 text-primary d-flex align-items-center gap-2'>For view Wound Care notes please click on <VisibilityOutlinedIcon /> icon in the table</span>
              <DynamicTable
                columns={WOUND_LISTING_COLOUMS}
                data={filteredData}
                loadingStates={loadingStates}
                canUpdate={hasPermission(userPermissions, permissions.wound_care_update)}
                onUpdate={handleUpdate}
                canView={hasPermission(userPermissions, permissions.wound_care_entries_view)}
                onView={handleView}
                columnDataMapping={WOUND_DATA_MAPPING}
                sortingColumns={WOUND_SORTING_DATA}
                clickableRow={false}
                queryData={queryData}
                setQueryData={setQueryData}
                tableLoader={isFetchingData}
              />
              </>
            }
          />
        </div>
      </div>
    </div>
  )
}

export default DeletedWoundCareList
